import { REVALIDATE_TIME } from '@/constants';

async function request(
  key: string,
  options: any = { next: { revalidate: REVALIDATE_TIME } }
): Promise<any> {
  try {
    const url = key;
    const response = await fetch(url, options);
    const data = await response.json();
    return { data, response };
  } catch (error: any) {
    return { error };
  }
}

const httpFetch = {
  get: (url: string, options?: any) =>
    request(url, { next: { revalidate: REVALIDATE_TIME }, ...options }),
  post: (url: string, body: any, options?: any) =>
    request(url, {
      ...options,
      next: { revalidate: REVALIDATE_TIME },
      method: 'POST',
      body: JSON.stringify(body),
    }),
  put: (url: string, body: any, options?: any) =>
    request(url, {
      ...options,
      next: { revalidate: REVALIDATE_TIME },
      method: 'PUT',
      body: JSON.stringify(body),
    }),
  delete: (url: string, options?: any, body?: any) =>
    request(url, {
      method: 'DELETE',
      next: { revalidate: REVALIDATE_TIME },
      ...options,
      ...(body && { body: JSON.stringify(body) }),
    }),
};

export default httpFetch;
